import actionTypes from './index';

export default result => ({ type: actionTypes.VERIFIED_ADDRESS, payload: result });
